import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { fade } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles(theme => ({
  root: {
    border: `1px solid ${theme.palette.ivory.light}`,
    borderRadius: 4,
    backgroundColor: theme.palette.background.ivory,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:hover': {
      backgroundColor: theme.palette.white,
      border: `1px solid ${theme.palette.ivory.medium}i`
    },
    '&$focused': {
      backgroundColor: theme.palette.white,
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main
    }
  },
  focused: {}
}));

const EmailInput = ({ ...rest }) => {
  const classes = useStyles();
  return (
    <TextField
      label="Email"
      type="email"
      name="username"
      autoComplete="email"
      fullWidth
      required
      margin="normal"
      variant="filled"
      InputProps={{ classes, disableUnderline: true }}
      {...rest}
    />
  );
};

export default EmailInput;
